<template>
    <div class="stockDia">
        <!-- 查看sku的批次信息 -->
        <el-dialog :title="$t('other.a2413')" :visible.sync="purchaseHistoryDiaCopy" width="70%"
            @close="$emit('update:purchaseHistoryDia', false)">
            <div>
                <el-table :data="purchaseList" border height="400px">
                    <el-table-column :label="$t('other.a511')" prop="purchaseOrderId"></el-table-column>
                    <el-table-column :label="$t('other.a67')" prop="cuscode"></el-table-column>
                    <el-table-column :label="$t('other.a1125')" prop="amount"></el-table-column>
                    <el-table-column :label="$t('other.a2137')" prop="price"></el-table-column>
                    <el-table-column :label="$t('other.a2414')" prop="extraFeeAverage"></el-table-column>
                    <el-table-column :label="$t('other.a2128')" prop="fbsCostAverage"></el-table-column>
                    <el-table-column :label="$t('other.a2415')" prop="logisticsCostAverage"></el-table-column>
                    <el-table-column :label="$t('other.a2416')" prop="createTime"></el-table-column>
                </el-table>
            </div>


            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="purchaseHistoryDiaCopy = false">{{ $t('other.a5') }}</el-button>
            </span>
        </el-dialog>


        <!-- 查看产品的代理商 -->
        <el-dialog :title="$t('other.a2417')" :visible.sync="agentDialogCopy" width="30%"
            @close="$emit('update:agentDialog', false)">

            <div class="gidan">
                <el-table v-if="agentList" :data="agentList" border height="400px">
                    <el-table-column :label="$t('other.a2418')">
                        <template slot-scope="props">
                            <span>{{ props.row.userName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="userId">
                        <template slot-scope="props">
                            <span>{{ props.row.userId }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('other.a2419')">
                        <template slot-scope="props">
                            <span>{{ props.row.cusCode }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="agentDialogCopy = false">{{ $t('other.a5') }}</el-button>
            </span>
        </el-dialog>
        <!-- 新增赠品/耗材 -->
        <el-dialog :title="$t('other.a2420')" :visible.sync="openDialogCopy" @close="$emit('update:openDialog', false)"
            width="60%">
            <div>
                <el-form :model="productInfo" label-width="100px" class="demo-ruleForm">
                    <el-form-item :label="$t('other.a66')">

                        <el-upload class="avatar-uploader" :headers="token"
                            action="https://erp.shopsbu.com/service/access/upload" :show-file-list="false"
                            :on-success="handleAvatarSuccess">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item :label="$t('other.a2139')">
                        <el-input v-model="productInfo.name" :placeholder="$t('other.a2423')"></el-input>
                    </el-form-item>
                    <el-form-item label="skuName">
                        <el-input v-model="productInfo.variationName" :placeholder="$t('other.a2424')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a2421')">
                        <el-input v-model="productInfo.weigth" :placeholder="$t('other.a2425')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a2422')">
                        <div style="display:flex">
                            <el-input style="width:120px;padding:0 5px" v-model="productInfo.long"
                                :placeholder="$t('other.a2426')"></el-input>
                            X <el-input style="width:120px;padding:0 5px" v-model="productInfo.width"
                                :placeholder="$t('other.a2427')"></el-input>
                            X <el-input style="width:120px;padding:0 5px" v-model="productInfo.height"
                                :placeholder="$t('other.a2428')"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('other.a3416')" v-if="handleParam.putAway && handleParamtype == 0">
                        <el-input v-model="productInfo.price"></el-input>
                    </el-form-item>


                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="openDialogCopy = false">{{ $t('other.a106') }}</el-button>
                <el-button type="primary" @click="submitProduct(false)" v-if="!handleParam.putAway && handleParamtype == 0">{{ $t('other.a274') }}</el-button>
                <el-button type="primary" @click="submitProduct(true)" v-if="handleParam.putAway && handleParamtype == 0">确认并同步到所有分销代理商</el-button>
            </span>
        </el-dialog>
        <!-- 绑定线上产品 -->
        <el-dialog :title="$t('other.a2429')" :visible.sync="showProductCopy" width="70%"
            @close="$emit('update:showProduct', false)">
            <div v-if="showProductCopy" class="vinf">
                <div class="olineTitle">
                    <div class="pic"><img :src="onlineItems.sku.image" /></div>
                    <div class="desc">
                        <div>{{ $t('other.a2139') }}：{{ onlineItems.sku.skuName }}</div>
                        <div>skuName：{{ onlineItems.sku.variationName }}</div>
                        <div>{{ $t('other.a226') }}{{ onlineItems.sku.cusCode }}</div>
                    </div>

                </div>
                <div>
                    <el-button size="medium" type="info" @click="exportOnlineItem()">{{ $t('other.a72') }}</el-button>
                    <el-button size="medium" type="primary"
                        @click="bindItemCusCode(onlineItems.sku.cusCode, onlineItems.storeId, onlineItems.sku.component)">{{
                            $t('other.a2430') }}
                    </el-button>
                </div>
            </div>
            <div class="gidan">
                <el-table v-if="onlineItems" :data="onlineItems.list" border height="400px">
                    <el-table-column :label="$t('other.a30')" width="70">
                        <template slot-scope="props">
                            <div class="pic"><img :src="props.row.image"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="sku">
                        <template slot-scope="props">
                            <div>sku：{{ props.row.variationSku }}</div>
                            <div>skuName：{{ props.row.variationName }}</div>
                            <div>itemKey：{{ props.row.itemKey }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="shopInfo">
                        <template slot-scope="props">
                            <div>{{ $t('other.a592') }}：{{ showName(props.row.shopId) }}</div>
                            <div>{{ $t('other.a838') }}Id：{{ props.row.shopId }}</div>
                            <div>{{ $t('other.a68') }}：{{ props.row.itemId }}</div>
                            <div>{{ $t('other.a2431') }} ：{{ props.row.price }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('other.a33')">
                        <template slot-scope="props">
                            <div><el-button size="medium" type="primary" @click="jiebang(props.row, props.$index)">{{
                                $t('other.a193') }}</el-button></div>
                            <!-- <div style="margin-top:10px;"><el-button size="medium" type="primary" @click="setVartualSku(props.row,props.$index)">设为虚拟sku链接</el-button></div> -->
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showProductCopy = false">{{ $t('other.a5') }}</el-button>
            </span>
        </el-dialog>

        <!-- 绑定的库存产品 -->
        <el-dialog :title="$t('other.a2432')" :visible.sync="bindProductCopy" width="70%"
            @close="$emit('update:bindProduct', false)">
            <div v-if="bindProductCopy" class="vinf">
                <div class="olineTitle">
                    <div class="pic"><img :src="onlineItems.sku.image" /></div>
                    <div class="desc">
                        <div>{{ $t('other.a2139') }}：{{ onlineItems.sku.skuName }}</div>
                        <div>skuName：{{ onlineItems.sku.variationName }}</div>
                        <div>{{ $t('other.a226') }}{{ onlineItems.sku.cusCode }}</div>
                    </div>

                </div>

            </div>
            <div class="gidan" v-if="bindProductCopy">
                <div class="jvin">{{ $t('other.a2433') }}（{{ onlineItems.list.length }}）</div>
                <el-table :data="onlineItems.list" border height="400px">
                    <el-table-column :label="$t('other.a30')" width="70">
                        <template slot-scope="props">
                            <div class="pic"><img :src="props.row.image"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="sku">
                        <template slot-scope="props">
                            <div>sku：{{ props.row.variationSku }}</div>
                            <div>skuName：{{ props.row.variationName }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="shopInfo">
                        <template slot-scope="props">
                            <div>{{ $t('other.a838') }}：{{ props.row.shopId }}</div>
                            <div>{{ $t('other.a68') }}：{{ props.row.itemId }}</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="bindProductCopy = false">{{ $t('other.a5') }}</el-button>
                <el-button type="primary" @click="bindGoods()">{{ $t('other.a2434') }}</el-button>

            </span>
        </el-dialog>

        <!-- 删除失败提示 -->
        <el-dialog :title="$t('other.a2435')" :visible.sync="errorDia" @close="$emit('update:showErrorDeleteItem', false)"
            width="60%">
            <el-table :data="listErrorOptions" border height="350px">
                <el-table-column label="product" width="80">
                    <template slot-scope="scope">
                        <div style="height: 60px;overflow: hidden;width: 60px;"><img style="width:100%"
                                :src="scope.row.storeItem.image" /></div>
                    </template>
                </el-table-column>
                <el-table-column label="cusCode">
                    <template slot-scope="scope">
                        <span style="color:red">{{ scope.row.storeItem.cusCode }}{{ $t('other.a2436') }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Fail Reason">
                    <template slot-scope="scope">
                        <span style="color:red">{{ $t('other.a677') }}：{{ scope.row.desc }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="errorDia = false">{{ $t('other.a955') }}</el-button>
            </span>
        </el-dialog>

        <!-- 成功或失败绑定的提示 -->
        <el-dialog :title="$t('other.a2437')" :visible.sync="storetable" center width="80%">
            <div class="quit-wapper">
                <span class="quit-wrapper-item">
                    <i class="iconfont icon-gouSolid-copy vbfk"></i>
                    {{ succesList.length }}{{ $t('other.a2438') }}</span>
                <span class="quit-wrapper-item">
                    <i class="iconfont icon-jinggao1 vbfkh"></i>
                    {{ errorList.length }}{{ $t('other.a2439') }}</span>
            </div>
            <div class="quit-box">
                <el-table style="margin-left: 10px;" :data="succesList" height="460px" border>
                    <el-table-column property="name" :label="$t('mygoods').details.Img" width="60"
                        :show-overflow-tooltip="true">
                        <template scope="scope">
                            <el-popover placement="top-start" title="" trigger="hover">
                                <img :src="scope.row.image" style="width: 150px;height: 150px" />
                                <img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column property="variationSku" :label="$t('mygoods').details.SKU" width="150"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="cusCode" :label="$t('mygoods').details.cusCode"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table>
                <el-table style="margin-left: 10px;" :data="errorList" height="460px" border>
                    <el-table-column property="name" :label="$t('mygoods').details.Img" width="60"
                        :show-overflow-tooltip="true">
                        <template scope="scope">
                            <el-popover placement="top-start" title="" trigger="hover">
                                <img :src="scope.row.image" style="width: 150px;height: 150px" />
                                <img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column property="产品已绑定" :label="$t('other.a688')">
                        <template scope="scope">
                            <span>{{ $t('other.a2440') }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="ttp-uu">
                <el-button type="primary" @click="backTo()">{{ $t('other.a2441') }}</el-button>
            </div>
        </el-dialog>
        <!-- 店铺选择 -->
        <el-dialog :title="$t('other.a2442')" :visible.sync="showshopOptionCopy"
            @close="$emit('update:showshopOption', false)" width="50%">
            <div style="font-size:16px;margin-bottom:20px">
                <p style="font-size:20px;margin-bottom:10px;color:red">{{ $t('other.a2443') }}</p>
                <p>{{ $t('other.a2444') }}</p>
                <p>{{ $t('other.a2445') }}</p>
                <p>{{ $t('other.a2446') }}<br />{{ $t('other.a2447') }}</p>
            </div>
            <div>{{ $t('other.a2448') }}：
                <el-select v-model="shopeIdvalue" :placeholder="$t('other.a1359')">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <i v-show="progressValue == 100" class="el-icon-loading"></i>
                <span v-show="progressValue == 100">{{ $t('other.a2449') }}</span>
            </div>
            <!-- <div  class="process">
                <el-progress type="circle" :percentage="progressValue"></el-progress>
                <div v-show="progressValue < 100" class="jvknf">{{$t('other.a2449')}}</div>
                <div v-show="progressValue == 100" class="jvknf">
                    <p class="p_desc">已完成产品导入，本次成功导入2014个库存产品，共5241个sku</p>
                    <p class="p_desc">成功绑定线上120个sku,绑定失败110个sku</p>
                    <p class="p_desc">详细请查看 导入详情</p>
                </div>
            </div> -->
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showshopOptionCopy = false">{{ $t('other.a5') }}</el-button>
                <el-button type="primary" @click="confirmBtn()">{{ $t('other.a274') }}</el-button>
            </span>
        </el-dialog>


        <!-- 配置套餐 -->
        <el-dialog :title="$t('other.a2450')" :visible.sync="openDiaconfigPackageCopy"
            @close="$emit('update:openDiaconfigPackage', false)" width="80%">
            <div style="text-align:right;margin-bottom:10px">
                <el-button type="primary" @click="getShopItem()">{{ $t('other.a2451') }}</el-button>
            </div>
            <el-table :data="packageList" border height="450px">
                <el-table-column width="80" :label="$t('other.a66')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-popover placement="top-start" title="" trigger="hover">
                            <img :src="scope.row.image" alt="" style="width: 150px;height: 150px">
                            <img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a67')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ scope.row.cusCode }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="sku" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ scope.row.skuName }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a2452')">
                    <template slot-scope="scope">
                        <el-input-number size="mini" v-model="scope.row.rate" :min="1"></el-input-number>

                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a1037')">
                    <template slot-scope="scope">
                        <span>{{ scope.row.stock }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a33')" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="deletGoods(scope.$index)">{{ $t('other.a312')
                        }}</el-button>

                    </template>
                </el-table-column>

            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="saveItems()">{{ $t('other.a2455') }}</el-button>
                <el-button type="primary" @click="openDiaconfigPackageCopy = false">{{ $t('other.a5') }}</el-button>
            </span>
        </el-dialog>


        <!-- 配件列表 -->
        <el-dialog :title="$t('other.a2453')" :visible.sync="singlGoodsDia" width="90%">
            <div style="width: 100%;">
                <div>
                    <div style="padding-bottom: 10px;">
                        <el-input style="width: 30%;" v-model="searchCuscode" :placeholder="$t('other.a2454')"
                            clearable></el-input>
                        <el-button type="primary" @click="search()">{{ $t('other.a27') }}</el-button>
                    </div>
                </div>
                <div>
                    <el-table :data="tableList" height="400px" style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column prop="outTradeNo" :label="$t('other.a66')" width="80">
                            <template slot-scope="props">
                                <el-popover placement="top-start" title="" trigger="hover">
                                    <img :src="props.row.image" alt="" style="width: 150px;height: 150px">
                                    <img slot="reference" :src="props.row.image" style="width: 30px;height: 30px">
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('other.a67')" width="180">
                            <template slot-scope="props">
                                <span>{{ props.row.cusCode }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column prop="skuName" :label="$t('other.a2139')">
                            <template slot-scope="props">
                                <span>{{ props.row.skuName ? props.row.skuName : $t('other.a260') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="variationName" label="skuName">
                            <template slot-scope="props">
                                <span>{{ props.row.variationName ? props.row.variationName : $t('other.a260') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="platform" :label="$t('other.a2456')">
                            <template slot-scope="props">
                                <el-input-number size="mini" v-model="props.row.rate" :min="1"></el-input-number>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="width: 100%;display: flex;justify-content: flex-end;">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="dataParam.offset"
                            layout="total, sizes, prev, pager, next, jumper" :total="tableListCount">
                        </el-pagination>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="singlGoodsDia = false">{{ $t('other.a106') }}</el-button>
                <el-button type="primary" @click="addStoreItem()">{{ $t('other.a274') }} </el-button>

            </span>
        </el-dialog>

    </div>
</template>

<script>
import echarts from 'echarts'
import utils from '../../../utils/utils.js'
import newOrder from '../../../api/moudles/newOrders'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
import {
    mapState,
    mapActions,
    mapMutations
} from 'vuex'
import api from '../../../api/api.js'
import gallery from '../../../api/moudles/gallery.js'
export default {
    name: "Dialog",
    data() {
        return {
            showProductCopy: false,
            agentDialogCopy: false,
            bindProductCopy: false,
            storetable: false,
            succesList: [],
            errorList: [],
            errorDia: false,
            options: [],
            shopeIdvalue: null,
            showshopOptionCopy: false,
            openDiaconfigPackageCopy: false,
            purchaseHistoryDiaCopy: false,
            openDialogCopy: false,
            singlGoodsDia: false,
            searchCuscode: null,
            imageUrl: null,
            tableList: [],
            token: {
                token: JSON.parse(localStorage.getItem('userInfo')).token
            },
            productInfo: {
                imageUrl: '',
                name: '',
                long: '',
                width: '',
                height: '',
                weigth: '',
                variationName: ''
            },
            dataParam: {
                offset: 30,
                page: 0,
                userId: this.userId,
                storeId: null,
                sellerId: null,
                cusCode: null,
                component: true
            },
            currentPage: 0,
            tableListCount: 0,
            multipleSelection: [],
            progressValue: 0


        };
    },

    computed: {
        ...mapState({
            userId: state => state.shopaccess.userInfo.userId,
        }),

    },
    props: {
        showProduct: {
            type: Boolean,
            default: false
        },

        packageInfo: {
            type: Object,
            default: () => { }
        },

        onlineItems: {
            type: Object,
            default: () => { }
        },
        packageList: {
            type: Array,
            default: () => []
        },
        purchaseList: {
            type: Array,
            default: () => []
        },
        showshopOption: {
            type: Boolean,
            default: false
        },
        bindProduct: {
            type: Boolean,
            default: false
        },
        openDiaconfigPackage: {
            type: Boolean,
            default: false
        },
        showErrorDeleteItem: {
            type: Boolean,
            default: false
        },
        purchaseHistoryDia: {
            type: Boolean,
            default: false
        },
        openDialog: {
            type: Boolean,
            default: false
        },
        handleParam: {
            type: Object,
            default: {}
        },
        handleParamtype: {
            type: Number,
            default: 0
        },
        listErrorOptions: {
            type: Array,
            default: () => []
        },
        agentDialog: {
            type: Boolean,
            default: false
        },
        agentList: {
            type: Array,
            default: () => []
        },

    },
    watch: {
        openDialog() {
            this.openDialogCopy = this.openDialog
            if (!this.openDialog) {
                this.productInfo.imageUrl = null
                this.productInfo.name = null
                this.productInfo.long = null
                this.productInfo.width = null
                this.productInfo.height = null
                this.productInfo.weigth = null
                this.productInfo.variationName = null
                this.imageUrl = null

            }
        },
        agentDialog() {
            this.agentDialogCopy = this.agentDialog
        },
        showProduct() {
            this.showProductCopy = this.showProduct
        },
        purchaseHistoryDia() {
            this.purchaseHistoryDiaCopy = this.purchaseHistoryDia
        },
        bindProduct() {
            this.bindProductCopy = this.bindProduct
        },
        showErrorDeleteItem() {
            this.errorDia = this.showErrorDeleteItem
        },
        showshopOption() {
            if (this.showshopOption) {
                this.options = utils.getShopeeAndLazadaShopInfo()
            } else {
                this.progressValue = 0
            }
            this.showshopOptionCopy = this.showshopOption
        },
        openDiaconfigPackage() {
            this.openDiaconfigPackageCopy = this.openDiaconfigPackage

        },
        searchCuscode() {
            if (!this.searchCuscode) {
                this.dataParam.cusCode = null
                this.dataParam.page = 0
                this.getUserstoreItem()
            }
        }
    },
    created() {

    },

    methods: {
        ...mapActions('order', [
            'getPrintSheetHistory',
            'getPrintTogether',
            'getGoodsOrder',
            'getSpeciesOrder',
            'getStoreItem',
            'getShopAllItems',
            'viewLogistics',
            'fill_In_logisticsNumber',
            'reloadOrder'


        ]),

        ...mapActions('userStoreItems', [
            'jiebanItems',
            'updateBindStoreItem'
        ]),

        showName(id) {
            return utils.showShopNameByshopId(id)
        },

        search() {
            this.dataParam.cusCode = this.searchCuscode
            this.getUserstoreItem()
        },
        handleAvatarSuccess(res, file) {
            console.log(res, file)
            this.imageUrl = res.data;
        },

        submitProduct(status) {
            if (!this.imageUrl) {
                this.$message.warning(this.$t('other.a2457'))
                return
            }
            if (!this.productInfo.name) {
                this.$message.warning(this.$t('other.a2458'))
                return
            }

            if (!this.productInfo.variationName) {
                this.$message.warning(this.$t('other.a2459'))
                return
            }
            if(this.handleParam.putAway && this.handleParamtype == 0&&!this.productInfo.price){
                this.$message.warning(this.$t('other.a3417'))
                return
            }
            this.productInfo.imageUrl = JSON.parse(JSON.stringify(this.imageUrl))
            this.productInfo.isUpdateParents = status
            this.$emit('createItemNotProduct', this.productInfo)
            this.openDialogCopy = false
            this.imageUrl = ''
        },

        saveItems() {

            let arr = this.packageList.map(p => {
                return {
                    childrenId: p.cusCode,
                    parentId: this.packageInfo.cusCode,
                    rate: p.rate
                }
            })
            let params = {
                binds: arr,
                parentId: this.packageInfo.cusCode,
                userId: this.userId
            }

            console.log(params)
            this.updateBindStoreItem(params)
        },

        addStoreItem() {
            this.multipleSelection.forEach(p => {
                let obj = this.packageList.find(item => item.cusCode == p.cusCode)
                if (obj) {
                    this.$message.warning(this.$t('other.a2460') + obj.cusCode + this.$t('other.a2461'))
                } else {
                    this.packageList.push(p)
                }
            })

            this.singlGoodsDia = false
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;


            console.log(this.multipleSelection)
        },
        // 获取配件列表
        getShopItem() {
            console.log(this.packageInfo)
            this.dataParam.storeId = this.packageInfo.storeId
            this.dataParam.userId = this.userId
            console.log(this.dataParam)
            console.log(this.packageList)
            this.getUserstoreItem()

        },

        getUserstoreItem() {
            this.tableList = []
            userStoreItemsApi
                .getStoreItem(this.dataParam)
                .then(res => {
                    if (res.code === 200) {
                        console.log('海外仓库数据', res.data)
                        this.singlGoodsDia = true
                        res.data.groups.forEach(p => {
                            p.storeItems.forEach(i => {
                                this.tableList.push(i)
                            })
                        })
                        this.tableListCount = res.data.count

                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.dataParam.offset = parseInt(`${val}`)
            this.handleCurrentChange()
        },

        //显示当前第几页
        handleCurrentChange(val) {
            this.currentPage = parseInt(`${val}`)
            this.dataParam.page = (parseInt(`${val}`) - 1) * this.dataParam.offset
            this.getUserstoreItem()


        },

        deletGoods(index) {
            this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a235'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
            }).then(() => {
                this.packageList.splice(index, 1)
            })
        },

        jiebang(item, index) {
            this.$confirm(this.$t('other.a209'), this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a145'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
            }).then(() => {
                this.jiebanItems({
                    itemKey: item.itemKey,
                    userId: this.userId
                }).then(res => {
                    if (res.code === 200) {
                        this.$message.success(this.$t('other.a1699'))
                        this.onlineItems.list.splice(index, 1)
                    } else {
                        this.$message.warning(res.msg)
                    }
                })

            })


        },

        setVartualSku(params) {
            this.$emit('setVartualSku', params)
        },

        confirmBtn() {
            // this.addItemBoss()
            this.progressValue = 100
            this.$emit('oneImport', this.shopeIdvalue)
        },
        addItemBoss() {
            this.progressValue += 20
            if (this.progressValue < 100) {
                setTimeout(() => {
                    this.addItemBoss()
                }, 1000);
            }
        },
        backTo() {
            this.storetable = false
            console.log(this.$route.query.components)
            if (this.$route.query.components == 'true') {
                this.$router.push({
                    path: '/stockProduct/single'
                })
            }
            if (this.$route.query.components == 'false') {
                this.$router.push({
                    path: '/stockProduct/combo'
                })
            }
        },

        bindItemCusCode(cusCode, storeId, components) {
            this.$router.push({
                path: '/bindGoods',
                query: {
                    cusCode: cusCode,
                    storeId: storeId,
                    components: components,
                    from: this.$route.path
                }
            })
        },

        exportOnlineItem() {
            console.log(this.onlineItems)
            let list = this.onlineItems.list
            let arr = []
            list.forEach(p => {
                p.createTime = utils.getCurrnetTime(p.createTime)
                arr.push({
                    '店铺名称': this.showName(p.shopId),
                    '店铺Id': p.shopId,
                    '商品Id': p.itemId,
                    'sku': p.variationSku,
                    'cusCode': p.cusCode,
                    'skuName': p.variationName,
                    'itemKey': p.itemKey,
                    '折后价': p.price,

                })
            })
            console.log('arr', arr)

            let list2 = ['店铺名称', '店铺Id', '商品Id', 'sku', 'cusCode', 'skuName', 'itemKey', '折后价']

            utils.exPortEXml(arr, list2, list2)

        },
        //绑定产品
        bindGoods() {
            console.log(this.onlineItems)
            let list = this.onlineItems.list.map(p => {
                return {
                    cusCode: this.$route.query.cusCode,
                    itemKey: p.itemKey,
                    shopId: p.shopId,
                    userId: this.userId
                }
            })
            console.log(list)
            newOrder
                .bindByItemKey(list)
                .then(res => {
                    if (res.code === 200) {
                        console.log('desc', res.data)
                        this.succesList = res.data.success
                        this.errorList = res.data.error
                        this.bindProductCopy = false
                        this.storetable = true


                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        }



    }
}
</script>

<style lang="scss" scoped>
.stockDia {

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        border: 1px solid #8c939d;
    }

    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }

    .el-icon-loading {
        color: #409EFF;
        font-size: 25px;
        margin: 0 15px;
    }

    .process {
        text-align: center;
        padding: 20px 0 0 0;

        .jvknf {
            padding: 10px 0 0 0;
        }

        .p_desc {
            padding-bottom: 5px;
        }

    }

    .pic {
        width: 60px;
        height: 60px;
        overflow: hidden;

        img {
            width: 100%;
        }
    }

    .vinf {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;

    }

    .olineTitle {
        display: flex;
        align-items: center;

        .desc {
            font-size: 16px;
            font-weight: bold;
            padding: 0 15px;
        }


    }

    .gidan {
        margin-top: 10px;

        .jvin {
            font-size: 18px;
            font-weight: 500;
            padding: 10px 15px;
            line-height: 24px;
            color: #303133;
        }
    }

    .quit-box {
        display: flex;
    }

    .quit-wapper {
        display: flex;

        .quit-wrapper-item {
            width: 50%;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: rgb(0, 199, 163);
        }

        .quit-wrapper-item:nth-child(2) {
            width: 50%;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: rgb(255, 82, 69);
        }

        .vbfkh {
            color: rgb(255, 82, 69);
            font-size: 20px;
            margin-right: 15px;
        }

        .vbfk {
            color: rgb(0, 199, 163);
            font-size: 20px;
            margin-right: 15px;
        }

    }

    .ttp-uu {
        text-align: right;
        margin-top: 20px;
    }



    /deep/ .el-dialog__body {
        padding: 5px 10px
    }
}
</style>
